import styled from 'styled-components';

const commonGameAssetsFolder =
  process.env.NEXT_PUBLIC_CLOUDFRONT_STATIC_HOST + '/commonGameAssets';

export const StyledRaceConceptAnimation = styled.div.attrs((props) => ({
  style: {
    '--toX': props.velocityX <= 0 ? `${Math.abs(props.velocityX) * 30}%` : '0%',
    '--fromX':
      props.velocityX > 0 ? `${Math.abs(props.velocityX) * 30}%` : '0%',
  },
}))`
  position: absolute;
  width: 100%;
  height: 100%;
  .race {
    height: 100%;
    .race-floor {
      position: absolute;
      top: calc(40%);
      width: 100%;
      height: 100px;
      background-image: url('${commonGameAssetsFolder}/classic/concept-race/race-floor.png');
      background-position: top;
      background-repeat: repeat-x;
      animation: bg-parallax 15s linear infinite;
    }
  }

  @keyframes bg-parallax {
    from {
      background-position: var(--fromX) top;
    }
    to {
      background-position: var(--toX) 0;
    }
  }
`;
